export enum FileType {
  Documents = 'documents', //This is the folder where the uploaded images will be uploaded on AWS. That is why there is only one
}
